import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaSpinnerComponent} from './la-spinner.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LaSpinnerComponent],
  exports: [LaSpinnerComponent]
})
export class LaSpinnerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaSpinnerModule,
      providers: []
    };
  }
}
